module.exports = __webpack_public_path__ + "img/scholz-kanzler.5b37c46f.png";